import { FC, ReactNode } from "react";

interface ContentContainerProps {
  children: ReactNode
  size?: "sm" | "md" | "lg" // defaults to MD
}

export const ContentContainer: FC<ContentContainerProps> = props => {
  const maxWidth = {
    "sm": "max-w-(--breakpoint-sm)",
    "md": "max-w-(--breakpoint-lg)",
    "lg": "max-w-(--breakpoint-xl)",
  }[props.size ?? "md"]
  return <div className={`${maxWidth} mx-auto`}>
    {props.children}
  </div>
}
